import { gql } from '@apollo/client';
import MetricResult from '../types/metrics/metricResult';
import { MetricEntityType, MetricFilter } from '../types/metrics/metricFilter';

const metrics = gql`
  query Metrics($filter: MetricFilterInput, $type: MetricEntityType!) {
    metrics(filter: $filter, type: $type) {
      companyId
      label
      value
      type
    }
  }
`;

export interface MetricsResponse {
  metrics: MetricResult[];
}

export interface MetricsVariables {
  filter?: MetricFilter;
  type: MetricEntityType;
}

export const DashboardQueries = {
  metrics,
};
